import { Box } from '@mui/material';
import { AdminModuleFrame } from '@/components/AdminPortal/AdminModuleFrame';
import { adminModuleComponents } from '@/pages/Admin/adminModuleRegistry';
import { AdminPlaceholderPage } from '@/pages/Admin/modules/AdminPlaceholderPage';
import type { AdminModuleDefinition } from '@/types/adminModule';
import { resolveAdminModuleUrl } from '@/utils/adminModuleUrl';

interface AdminModuleContentProps {
  module: AdminModuleDefinition;
  moduleId: string;
  title: string;
}

export function AdminModuleContent({
  module,
  moduleId,
  title,
}: AdminModuleContentProps) {
  if (module.contentType === 'external') {
    return (
      <AdminModuleFrame
        moduleId={moduleId}
        src={resolveAdminModuleUrl(module)}
        title={title}
      />
    );
  }

  const ModuleComponent = adminModuleComponents[moduleId];

  return (
    <Box
      sx={{
        flex: 1,
        minWidth: 0,
        minHeight: 0,
        height: '100%',
        overflow: 'auto',
        bgcolor: 'background.default',
      }}
    >
      {ModuleComponent ? (
        <ModuleComponent />
      ) : (
        <AdminPlaceholderPage moduleId={moduleId} />
      )}
    </Box>
  );
}
